import {useEffect} from 'react'

// The legacy Backoffice reset form is deprecated — authentication is on Keycloak (SSO). Any hit on
// /auth/forgotpassword (the web Backoffice "Forgot password?" link AND the i2go app's "Passwort
// vergessen?" deep link, which still points at https://infinity-backoffice.com/auth/forgotpassword)
// is redirected to the KC-native reset. We use a logout→reset bounce so a user with a lingering SSO
// session lands cleanly on the email form (a bare reset-credentials link would inherit the session).
// The KC reset mirrors the new password to the WordPress academy, so academy login works afterwards.
//
// Stage-aware: the KC realm base + client come from the same OIDC env the SSO login uses
// (REACT_APP_OIDC_AUTHORITY = https://auth[.dev].be-infinity.com/realms/infinity), so dev builds hit
// dev KC and prod builds hit prod KC. Prod values are only a fallback for a build without the env.
const AUTHORITY = (
  process.env.REACT_APP_OIDC_AUTHORITY || 'https://auth.be-infinity.com/realms/infinity'
).replace(/\/+$/, '')
const CLIENT_ID = process.env.REACT_APP_OIDC_CLIENT_ID || 'backoffice-web'

const RESET_URL = `${AUTHORITY}/login-actions/reset-credentials?client_id=${encodeURIComponent(CLIENT_ID)}`
const KC_RESET =
  `${AUTHORITY}/protocol/openid-connect/logout?client_id=${encodeURIComponent(CLIENT_ID)}` +
  `&post_logout_redirect_uri=${encodeURIComponent(RESET_URL)}`

export function ForgotPassword() {
  useEffect(() => {
    window.location.replace(KC_RESET)
  }, [])
  return null
}
